(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setHeaderHeightLive();

      window.addEventListener('resizeend', this.setHeaderHeight.bind(this));
      window.addEventListener('resizeend', this.setHeaderHeightLive.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => { this.preventHide = false; });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setHeaderHeightLive(event, zero) {
      document.documentElement.style.setProperty('--header-height-live', `${zero ? 0 : this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pronat-performance-composer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initComposer = (root) => {
      if (!root || root.dataset.ppBound === 'true') return;
      root.dataset.ppBound = 'true';

      root.querySelectorAll('[data-pp-finder]').forEach((finder) => {
        const buttons = [...finder.querySelectorAll('[data-pp-finder-filter]')];
        const items = [...finder.querySelectorAll('[data-pp-finder-item]')];
        const count = finder.querySelector('[data-pp-finder-count]');
        const empty = finder.querySelector('[data-pp-finder-empty]');

        const applyFilter = (filter) => {
          let visible = 0;
          items.forEach((item) => {
            const tags = (item.dataset.ppTags || '').split('||');
            const matches = filter === 'all' || tags.includes(filter);
            item.hidden = !matches;
            if (matches) visible += 1;
          });
          buttons.forEach((button) => {
            const isActive = button.dataset.ppFinderFilter === filter;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', String(isActive));
          });
          if (count) count.textContent = `${visible} produse afișate`;
          if (empty) empty.hidden = visible !== 0;
        };

        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const update = () => applyFilter(button.dataset.ppFinderFilter || 'all');
            if (typeof document.startViewTransition === 'function') {
              document.startViewTransition(update);
            } else {
              update();
            }
          });
        });
        applyFilter('all');
      });

      root.querySelectorAll('[data-pp-sticky-form]').forEach((form) => {
        const select = form.querySelector('[data-pp-sticky-variant]');
        const price = form.querySelector('[data-pp-sticky-price]');
        const button = form.querySelector('[data-pp-sticky-button]');
        if (!select) return;
        const updateVariant = () => {
          const option = select.options[select.selectedIndex];
          if (price) price.textContent = option.dataset.price || '';
          if (button) button.disabled = option.dataset.available !== 'true';
        };
        select.addEventListener('change', updateVariant);
        updateVariant();
      });
    };

    const boot = () => document.querySelectorAll('[data-pp-composer]').forEach(initComposer);

    if (!window.PronatPerformanceComposer) {
      window.PronatPerformanceComposer = { boot };
      document.addEventListener('shopify:section:load', (event) => {
        const root = event.target.matches('[data-pp-composer]') ? event.target : event.target.querySelector('[data-pp-composer]');
        initComposer(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pronat-vurcher-b2b"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setupVurcherB2B = () => {
      document.querySelectorAll('[data-vp-b2b]').forEach((section) => {
        if (section.dataset.vpReady === 'true') return;
        section.dataset.vpReady = 'true';
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        section.querySelectorAll('[data-vp-scroll]').forEach((link) => {
          link.addEventListener('click', (event) => {
            const href = link.getAttribute('href');
            if (!href || !href.startsWith('#')) return;
            const target = document.getElementById(href.slice(1));
            if (!target) return;
            event.preventDefault();
            target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
          });
        });
        if (section.dataset.singleFaq === 'true') {
          const items = [...section.querySelectorAll('[data-vp-faq]')];
          items.forEach((item) => {
            item.addEventListener('toggle', () => {
              if (!item.open) return;
              items.forEach((otherItem) => {
                if (otherItem !== item) otherItem.open = false;
              });
            });
          });
        }
        const success = section.querySelector('[data-vp-success]');
        if (success) window.requestAnimationFrame(() => success.focus());
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupVurcherB2B, { once: true });
    } else {
      setupVurcherB2B();
    }
    document.addEventListener('shopify:section:load', setupVurcherB2B);
  })();

  } catch(e) { console.error(e); }
})();
})();
